var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dash", class: { pdf: _vm.hideNavType == "pdf" } },
    [
      _c("portal-target", { attrs: { name: "dash" } }),
      _c("componentTootip"),
      _c("componentContextMenu"),
      _c("componentModal"),
      _c("requestManager"),
      _c("selectUsers"),
      _c("tableOverlay"),
      _c("TourOverlay"),
      _vm.navigatorUnmanaged && !_vm.useNavigatorUnmanaged
        ? _c("div", { staticClass: "navigator-unmanaged" }, [
            _c("div", [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("dash.navigator-unmanaged.title"))),
              ]),
              _c("div", {
                staticClass: "content",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("dash.navigator-unmanaged.content")),
                },
              }),
              _c(
                "div",
                {
                  staticClass: "content-use",
                  on: {
                    click: function ($event) {
                      return _vm.useNavigator()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("dash.navigator-unmanaged.content-use")))]
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dash-section",
          class: { blur: _vm.navigatorUnmanaged && !_vm.useNavigatorUnmanaged },
        },
        [
          _c("component-tabs", {
            attrs: {
              section: _vm.section,
              scrolled: this.fixed,
              userProp: this.user,
              checkDisclaimerPost: _vm.checkDisclaimerPost,
            },
            on: {
              "tab-clicked": _vm.update,
              "disclaimer-post": _vm.disclaimerPost,
              initTabsMinimize: _vm.initTabsMinimize,
            },
          }),
          _c(
            "div",
            {
              staticClass: "main-wrapper",
              class: [{ "screenshot-preview": _vm.screenshotPuppeteer }],
            },
            [
              _c("SelectPageSection", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      ["postCreator", "posts2"].includes(_vm.$route.name) ||
                      (_vm.$route.name == "reporting" && _vm.isReportingV2),
                    expression:
                      "['postCreator', 'posts2'].includes($route.name) || ($route.name == 'reporting' && isReportingV2)",
                  },
                ],
                attrs: {
                  "title-key":
                    _vm.$route.name === "reporting"
                      ? "dash.select_page_section.reporting"
                      : "dash.select_page_section.publications",
                  "filter-networks":
                    _vm.$route.name === "reporting"
                      ? ["facebook", "instagram", "linkedin", "tiktok"]
                      : [],
                },
              }),
              _c(
                "div",
                { staticClass: "main-content" },
                [
                  !["postCreator", "plan"].includes(_vm.$route.name)
                    ? _c("component-header", {
                        attrs: {
                          scrolled: this.scrolled,
                          userProp: this.user,
                          section: _vm.section,
                        },
                        on: {
                          "dropdown-clicked": _vm.update,
                          search: _vm.search,
                          clickAddPost: function ($event) {
                            _vm.addPostHeader = true
                          },
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "section large",
                      class: {
                        "section-fixed": _vm.scrolled == true,
                        accordeon:
                          !_vm.tabsIsMinimize &&
                          !(
                            [
                              "overview",
                              "pages",
                              "bots",
                              "sources",
                              "settings",
                              "invoice",
                              "plan",
                            ].includes(this.$route.name) ||
                            (_vm.$route.name == "reporting" &&
                              _vm.isReportingV2)
                          ),
                        [this.$route.name]: true,
                      },
                    },
                    [
                      _c("router-view", {
                        attrs: {
                          addBot: _vm.addBot,
                          addPostHeader: _vm.addPostHeader,
                          tabsIsMinimize: _vm.tabsIsMinimize,
                        },
                        on: {
                          "on-settings-changed": _vm.settings,
                          "on-show-onboarding": _vm.onboard,
                          "on-close-bot-form": function ($event) {
                            _vm.addBot = false
                          },
                          "on-close-post-form": function ($event) {
                            _vm.addPostHeader = false
                          },
                          "on-open-post-form": function ($event) {
                            _vm.addPostHeader = true
                          },
                          "disclaimer-post": _vm.disclaimerPost,
                          minimizeTabs: _vm.minimizeTabs,
                          hideNav: _vm.hideNav,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          staticClass: "overlay onboarding",
          attrs: { title: _vm.dialog.title, active: _vm.dialog.show },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.dialog, "show", $event)
            },
          },
        },
        [
          _vm.userPlan == "" && _vm.user && _vm.user.partner
            ? _c(
                "vs-row",
                [
                  _c(
                    "vs-col",
                    {
                      staticClass: "flex-d-c col-left",
                      attrs: { "vs-type": "flex", "vs-align": "center" },
                    },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.dialog.message))]),
                      _vm.dialog.gif == "page"
                        ? _c("img", {
                            attrs: {
                              src: require("../assets/img/onboarding/connectpage.gif"),
                            },
                          })
                        : _vm._e(),
                      _vm.dialog.gif == "post"
                        ? _c("img", {
                            attrs: {
                              src: require("../assets/img/onboarding/post.gif"),
                            },
                          })
                        : _vm._e(),
                      _vm.dialog.gif == "bot"
                        ? _c("img", {
                            attrs: {
                              src: require("../assets/img/onboarding/bot.gif"),
                            },
                          })
                        : _vm._e(),
                      _c(
                        "vs-button",
                        {
                          staticClass: "btn-img",
                          attrs: { color: "#b44884", "vs-type": "filled" },
                          on: {
                            click: function ($event) {
                              _vm.dialog.show = false
                              _vm.dialog.gif == "bot"
                                ? (_vm.addBot = true)
                                : _vm.update(1, `${_vm.dialog.gif}s`, {
                                    showDialog: true,
                                  })
                            },
                          },
                        },
                        [_c("p", [_vm._v(_vm._s(_vm.dialog.cta))])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "vs-row",
                [
                  _vm.dialog.gif == "page" || _vm.dialog.gif == "post"
                    ? _c(
                        "vs-col",
                        {
                          staticClass: "flex-d-c col-left",
                          attrs: { "vs-type": "flex", "vs-align": "center" },
                        },
                        [
                          _c("p", [_vm._v(_vm._s(_vm.dialog.message))]),
                          _vm.dialog.gif == "page"
                            ? _c("img", {
                                attrs: {
                                  src: require("../assets/img/onboarding/connectpage.gif"),
                                },
                              })
                            : _vm._e(),
                          _vm.dialog.gif == "post"
                            ? _c("img", {
                                attrs: {
                                  src: require("../assets/img/onboarding/post.gif"),
                                },
                              })
                            : _vm._e(),
                          _c("p"),
                          _c(
                            "vs-button",
                            {
                              staticClass: "btn-img",
                              attrs: { color: "#b44884", "vs-type": "filled" },
                              on: {
                                click: function ($event) {
                                  _vm.dialog.show = false
                                },
                              },
                            },
                            [_c("p", [_vm._v(_vm._s(_vm.dialog.cta))])]
                          ),
                        ],
                        1
                      )
                    : _vm.dialog.gif === "bot"
                    ? [
                        _c(
                          "vs-col",
                          {
                            staticClass: "flex-d-c col-left",
                            attrs: {
                              "vs-type": "flex",
                              "vs-align": "center",
                              "vs-xs": "12",
                              "vs-sm": "6",
                              "vs-lg": "6",
                            },
                          },
                          [
                            _c("p", [_vm._v(_vm._s(_vm.dialog.message))]),
                            _c("img", {
                              attrs: {
                                src: require("../assets/img/onboarding/bot.gif"),
                              },
                            }),
                            _c("p"),
                            _c(
                              "vs-button",
                              {
                                staticClass: "btn-img",
                                attrs: {
                                  color: "#b44884",
                                  "vs-type": "filled",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.dialog.show = false
                                    _vm.addBot = true
                                  },
                                },
                              },
                              [_c("p", [_vm._v(_vm._s(_vm.dialog.cta))])]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "vs-col",
                          {
                            staticClass: "flex-d-c col-right",
                            attrs: {
                              "vs-type": "flex",
                              "vs-align": "center",
                              "vs-xs": "12",
                              "vs-sm": "6",
                              "vs-lg": "6",
                            },
                          },
                          [
                            _c("p", [_vm._v(_vm._s(_vm.dialog.message2))]),
                            _c("img", {
                              attrs: {
                                src: require("../assets/img/onboarding/sources.gif"),
                              },
                            }),
                            _c("p"),
                            _c(
                              "vs-button",
                              {
                                staticClass: "btn-img",
                                attrs: {
                                  color: "#b44884",
                                  "vs-type": "filled",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.dialog.show = false
                                    _vm.update(1, "sources", {
                                      showDialog: true,
                                    })
                                  },
                                },
                              },
                              [_c("p", [_vm._v(_vm._s(_vm.dialog.cta2))])]
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }